// extracted by css-extract-rspack-plugin
export default {"BarChartWrapper":"G9AMU","Summary":"epHzF"};